"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
Dodaje obsługę dla drzewa checkboxów, które wykorzystywane jest w edycji usługi DDoS w edycji firmy.

metody:
ApiCheckboxTree.init();
*/
var ApiCheckboxTree = /*#__PURE__*/function () {
  function ApiCheckboxTree() {
    _classCallCheck(this, ApiCheckboxTree);
  }

  _createClass(ApiCheckboxTree, null, [{
    key: "init",
    value: function init() {
      $('.checkbox-tree:not(.deletable) > li > .checkbox input').on('click', function () {
        if ($(this).prop('checked')) {
          $(this).closest('li').find('ul input').prop('checked', 1);
        } else {
          $(this).closest('li').find('ul input').prop('checked', 0);
        }
      });
    }
  }]);

  return ApiCheckboxTree;
}();
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classStaticPrivateMethodGet(receiver, classConstructor, method) { if (receiver !== classConstructor) { throw new TypeError("Private static access of wrong provenance"); } return method; }

var ApiCmsFixLayout = /*#__PURE__*/function () {
  function ApiCmsFixLayout() {
    _classCallCheck(this, ApiCmsFixLayout);
  }

  _createClass(ApiCmsFixLayout, null, [{
    key: "init",
    value: function init() {
      _classStaticPrivateMethodGet(ApiCmsFixLayout, ApiCmsFixLayout, _sidebar).call(ApiCmsFixLayout);

      _classStaticPrivateMethodGet(ApiCmsFixLayout, ApiCmsFixLayout, _fixLayout).call(ApiCmsFixLayout);

      _classStaticPrivateMethodGet(ApiCmsFixLayout, ApiCmsFixLayout, _dropDownBootstrap).call(ApiCmsFixLayout);
    }
  }]);

  return ApiCmsFixLayout;
}();

var _fixLayout = function _fixLayout() {
  var $body = $('body');
  var $header = $('#header'); //Top Search

  $body.on('click', '#top-search > a', function (e) {
    e.preventDefault();
    $header.addClass('search-toggled');
  });
  $body.on('click', '#top-search-close', function (e) {
    e.preventDefault();
    $header.removeClass('search-toggled');
  }); //Clear Notification

  $body.on('click', '[data-clear="notification"]', function (e) {
    e.preventDefault();
    var x = $(this).closest('.listview');
    var y = x.find('.lv-item');
    var z = y.size();
    $(this).parent().fadeOut();
    x.find('.list-group').prepend('<i class="grid-loading hide-it"></i>');
    x.find('.grid-loading').fadeIn(1500);
    var w = 0;
    y.each(function () {
      var z = $(this);
      setTimeout(function () {
        z.addClass('animated fadeOutRightBig').delay(1000).queue(function () {
          z.remove();
        });
      }, w += 150);
    }); //Popup empty message

    setTimeout(function () {
      $('#notifications').addClass('empty');
    }, z * 150 + 200);
  }); //Scrollbar for HTML(not mobile) but not for login page

  if (!$('html').hasClass('ismobile')) {
    if (!$('.login-content')[0]) {//ApiCmsFixLayout.#scrollbar('html', 'rgba(0,0,0,0.3)', '5px');
    } //Scroll bar for Chosen


    if ($('.chosen-results')[0]) {
      _classStaticPrivateMethodGet(ApiCmsFixLayout, ApiCmsFixLayout, _scrollbar).call(ApiCmsFixLayout, '.chosen-results', 'rgba(0,0,0,0.5)', '5px');
    } //Scroll bar for tabs


    if ($('.tab-nav')[0]) {
      _classStaticPrivateMethodGet(ApiCmsFixLayout, ApiCmsFixLayout, _scrollbar).call(ApiCmsFixLayout, '.tab-nav', 'rgba(0,0,0,0)', '1px');
    } //Scroll bar for dropdowm-menu


    if ($('.dropdown-menu .c-overflow')[0]) {
      _classStaticPrivateMethodGet(ApiCmsFixLayout, ApiCmsFixLayout, _scrollbar).call(ApiCmsFixLayout, '.dropdown-menu .c-overflow', 'rgba(0,0,0,0.5)', '0px');
    } //Scrollbar for rest


    if ($('.c-overflow')[0]) {
      _classStaticPrivateMethodGet(ApiCmsFixLayout, ApiCmsFixLayout, _scrollbar).call(ApiCmsFixLayout, '.c-overflow', 'rgba(0,0,0,0.5)', '5px');
    }
  } //Profile Menu


  $body.on('click', '.profile-menu > a', function (e) {
    e.preventDefault();
    $(this).parent().toggleClass('toggled');
    $(this).next().slideToggle(200);
  }); //Audio and Video

  if ($('audio, video')[0]) {
    // noinspection JSUnresolvedFunction
    $('video,audio').mediaelementplayer();
  } //Waves Animation


  if ($.isFunction(Waves)) {
    Waves.attach('a.btn, button.btn', ['waves-button', 'waves-float']);
    Waves.init();
  }

  var $lightbox = $('.lightbox'); //Lightbox

  if ($lightbox[0]) {
    $lightbox.lightGallery({
      enableTouch: true
    });
  } //Link prevent


  $body.on('click', '.a-prevent', function (e) {
    e.preventDefault();
  });
  var $collapse = $('.collapse'); //Collapse Fix

  if ($collapse[0]) {
    //Add active class for opened items
    // noinspection JSUnusedLocalSymbols
    $collapse.on('show.bs.collapse', function (e) {
      $(this).closest('.panel').find('.panel-heading').addClass('active');
    }); // noinspection JSUnusedLocalSymbols

    $collapse.on('hide.bs.collapse', function (e) {
      $(this).closest('.panel').find('.panel-heading').removeClass('active');
    }); //Add active class for pre opened items

    $('.collapse.in').each(function () {
      $(this).closest('.panel').find('.panel-heading').addClass('active');
    });
  }

  var $tooltips = $('[data-toggle="tooltip"]'); //Tooltips

  if ($tooltips[0]) {
    $tooltips.tooltip({
      html: true
    });
  }

  var $popovers = $('[data-toggle="popover"]'); //Popover

  if ($popovers[0]) {
    $popovers.popover({
      html: true
    });
  }

  var $onSelect = $('.on-select'); //Actions

  if ($onSelect[0]) {
    var checkboxes = '.lv-avatar-content input:checkbox';
    var actions = $onSelect.closest('.lv-actions');
    $body.on('click', checkboxes, function () {
      if ($(checkboxes + ':checked')[0]) {
        actions.addClass('toggled');
      } else {
        actions.removeClass('toggled');
      }
    });
  }

  if ($('#ms-menu-trigger')[0]) {
    $body.on('click', '#ms-menu-trigger', function (e) {
      e.preventDefault();
      $(this).toggleClass('open');
      $('.ms-menu').toggleClass('toggled');
    });
  }

  var $clearLocalStorage = $('[data-action="clear-localstorage"]'); //Clear Local Storage

  if ($clearLocalStorage[0]) {
    $clearLocalStorage.on('click', function (e) {
      e.preventDefault();
      swal({
        title: "Are you sure?",
        text: "All your saved localStorage values will be removed",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        closeOnConfirm: false
      }, function () {
        localStorage.clear();
        swal("Done!", "localStorage is cleared", "success");
      });
    });
  } //Profile Edit Toggle


  if ($('[data-pmb-action]')[0]) {
    $body.on('click', '[data-pmb-action]', function (e) {
      e.preventDefault();
      var d = $(this).data('pmb-action');

      if (d === "edit") {
        $(this).closest('.pmb-block').toggleClass('toggled');
      }

      if (d === "reset") {
        $(this).closest('.pmb-block').removeClass('toggled');
      }
    });
  }
};

var _dropDownBootstrap = function _dropDownBootstrap() {
  var $dropdown = $('.dropdown');
  var $animationDuration = '';
  var $animationIn, $animationOut; //Dropdown Menu

  if ($dropdown[0]) {
    //Propagate
    $('body').on('click', '.dropdown.open .dropdown-menu', function (e) {
      e.stopPropagation();
    }); // noinspection JSUnusedLocalSymbols

    $dropdown.on('shown.bs.dropdown', function (e) {
      if ($(this).attr('data-animation')) {
        var $animation = $(this).data('animation');
        var $animArray = $animation.split(',');
        $animationIn = 'animated ' + $animArray[0];
        $animationOut = 'animated ' + $animArray[1];

        if (!$animArray[2]) {
          $animationDuration = 500; //if duration is not defined, default is set to 500ms
        } else {
          $animationDuration = $animArray[2];
        }

        $(this).find('.dropdown-menu').removeClass($animationOut);
        $(this).find('.dropdown-menu').addClass($animationIn);
      }
    });
    $dropdown.on('hide.bs.dropdown', function (e) {
      if ($(this).attr('data-animation')) {
        e.preventDefault();
        var $this = $(this);
        var $dropdownMenu = $this.find('.dropdown-menu');
        $dropdownMenu.addClass($animationOut);
        setTimeout(function () {
          $this.removeClass('open');
        }, $animationDuration);
      }
    });
  }
};

var _sidebar = function _sidebar() {
  $('.close-right-menu').on('click', function (e) {
    e.preventDefault();
    $(this).parents('.right-menu').removeClass('toggled');
  });
  var $body = $('body');
  var $header = $('#header');
  var $rightMenu = $('#right-menu');
  var $sidebar = $('#sidebar'); //Sidebar

  $body.on('click', '#menu-trigger, .right-menu-trigger', function (e) {
    var $elem2 = '#menu-trigger';
    var $elem = '#sidebar';
    e.preventDefault();
    var x = $(this).data('trigger');
    $('.right-menu').removeClass('toggled');
    $(x).toggleClass('toggled');
    $(this).toggleClass('open'); // if ($(this).attr('id') !== 'right-menu-trigger') {
    //     $body.toggleClass('modal-open');
    // }
    //Close opened sub-menus

    $('.sub-menu.toggled').not('.active').each(function () {
      $(this).removeClass('toggled');
      $(this).find('ul').hide();
    });
    $('.profile-menu .main-menu').hide();

    if (x === '#sidebar') {
      $('#right-menu-trigger').removeClass('open');

      if (!$rightMenu.hasClass('toggled')) {
        $header.toggleClass('sidebar-toggled');
      } else {
        $rightMenu.removeClass('toggled');
      }
    } //When clicking outside


    if ($header.hasClass('sidebar-toggled')) {
      $(document).on('click', function (e) {
        if ($(e.target).closest($elem).length === 0 && $(e.target).closest($elem2).length === 0) {
          setTimeout(function () {
            $body.removeClass('modal-open');
            $($elem).removeClass('toggled');
            $header.removeClass('sidebar-toggled');
            $($elem2).removeClass('open');
          });
        }
      });
    }
  }); //Submenu

  $body.on('click', '.sub-menu > a', function (e) {
    e.preventDefault();
    $(this).next().slideToggle(200);
    $(this).parent().toggleClass('toggled');
  }); //Get saved layout type from LocalStorage

  var layoutStatus = localStorage.getItem('ma-layout-status');

  if (layoutStatus === 1) {
    $body.addClass('sw-toggled');
    $('#tw-switch').prop('checked', true);
  }

  $body.on('change', '#toggle-width input:checkbox', function () {
    if ($(this).is(':checked')) {
      setTimeout(function () {
        $body.addClass('toggled sw-toggled');
        localStorage.setItem('ma-layout-status', 1);
        animateMainmenu(0, 100); // TODO: Sprawdzić tę funkcję
      }, 250);
    } else {
      setTimeout(function () {
        $body.removeClass('toggled sw-toggled');
        localStorage.setItem('ma-layout-status', 0);
        $('.main-menu > li').removeClass('animated');
      }, 250);
    }
  });
  $sidebar.niceScroll({
    cursorcolor: '#FF6600',
    cursorborder: 0,
    cursorborderradius: 0,
    cursorwidth: 3,
    bouncescroll: true,
    mousescrollstep: 100,
    autohidemode: false,
    horizrailenabled: false
  });
  $sidebar.on('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function () {
    $('#sidebar').getNiceScroll().resize();
  });
};

var _scrollbar = function _scrollbar(className, color, cursorWidth) {
  $(className).niceScroll({
    cursorcolor: color,
    cursorborder: 0,
    cursorborderradius: 0,
    cursorwidth: cursorWidth,
    bouncescroll: true,
    mousescrollstep: 100
  });
};

var _detectMobile = function _detectMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
};
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classStaticPrivateMethodGet(receiver, classConstructor, method) { if (receiver !== classConstructor) { throw new TypeError("Private static access of wrong provenance"); } return method; }

var ApiForms = /*#__PURE__*/function () {
  function ApiForms() {
    _classCallCheck(this, ApiForms);
  }

  _createClass(ApiForms, null, [{
    key: "init",
    value: function init() {
      _classStaticPrivateMethodGet(ApiForms, ApiForms, _addDecorativeElements).call(ApiForms);

      var $colorPicker = $('.color-picker');
      var $selectPickers = $('.selectpickers');
      var $dateTimePicker = $('.date-time-picker');
      var $timePicker = $('.time-picker');
      var $datePicker = $('.date-picker');
      var $rootWizard = $('#rootwizard');
      var $htmlEditor = $('.html-editor');
      var $inputSlider = $('.input-slider');
      var $inputSliderRange = $('.input-slider-range');
      var $inputSliderValues = $('.input-slider-values');
      var $inputMask = $('.input-mask');
      var $tagSelect = $('.tag-select');
      var $autoSize = $('.auto-size');

      if ($colorPicker.length) {
        ApiForms.colorPicker($colorPicker);
      }

      if ($selectPickers.length) {
        ApiForms.customSelect($selectPickers);
      }

      if ($dateTimePicker.length) {
        ApiForms.datePickerTimeDate($dateTimePicker);
      }

      if ($timePicker.length) {
        ApiForms.datePickerTime($timePicker);
      }

      if ($datePicker.length) {
        ApiForms.datePickerDate($datePicker);
      }

      if ($rootWizard.length) {
        ApiForms.formWizard($rootWizard);
      }

      if ($htmlEditor.length) {
        ApiForms.htmlEditor($htmlEditor);
      }

      if ($inputSlider.length) {
        ApiForms.inputSlider($inputSlider);
      }

      if ($inputSliderRange.length) {
        _classStaticPrivateMethodGet(ApiForms, ApiForms, _inputSliderRange).call(ApiForms, $inputSliderRange);
      }

      if ($inputSliderValues.length) {
        _classStaticPrivateMethodGet(ApiForms, ApiForms, _inputSliderValue).call(ApiForms, $inputSliderValues);
      }

      if ($inputMask.length) {
        ApiForms.inputMask($inputMask);
      }

      if ($tagSelect.length) {
        ApiForms.tagSelect($tagSelect);
      }

      if ($autoSize.length) {
        ApiForms.textareaAutosize($autoSize);
      }

      if ($('.add-template').length) {
        _classStaticPrivateMethodGet(ApiForms, ApiForms, _addSubForm).call(ApiForms);
      }
    }
  }, {
    key: "colorPicker",
    value: function colorPicker($element) {
      //Color Picker
      if ($element.length) {
        $element.each(function () {
          $element.each(function () {
            var colorOutput = $(this).closest('.cp-container').find('.cp-value');
            $(this).farbtastic(colorOutput);
          });
        });
      }
    }
  }, {
    key: "customSelect",
    value: function customSelect($element) {
      //Custom Select
      if ($element.length) {
        $element.selectpicker();
      }
    }
  }, {
    key: "datePickerTimeDate",
    value: function datePickerTimeDate($element) {
      //Date Time Picker
      if ($element.length) {
        $element.each(function () {
          var $this = $(this);

          if ($this.is("[date-firstdate]")) {
            $element.datetimepicker({
              format: 'YYYY-MM-DD HH:mm',
              minDate: $this.attr('date-firstdate')
            });
          } else {
            $element.datetimepicker({
              format: 'YYYY-MM-DD HH:mm'
            });
          }
        });
      }
    }
  }, {
    key: "datePickerTime",
    value: function datePickerTime($element) {
      //Time
      if ($element.length) {
        $element.datetimepicker({
          format: 'LT'
        });
      }
    }
  }, {
    key: "datePickerDate",
    value: function datePickerDate($element) {
      //Date
      if ($element.length) {
        $element.datetimepicker({
          format: 'YYYY-MM-DD'
        });
      }
    }
  }, {
    key: "formWizard",
    value: function formWizard($element) {
      //Form Wizard
      var $rootWizard = $('#rootwizard');

      if ($element.length) {
        if (typeof $rootWizard.bootstrapWizard === 'function') {
          $rootWizard.bootstrapWizard({
            tabClass: '.tab-nav',
            previousSelector: '.navigation a.prev',
            nextSelector: '.navigation button.next',
            onTabShow: function onTabShow(tab, navigation, index) {
              var $total = navigation.find('li').length;
              var $current = index + 1;
              var $percent = $current / $total * 100;
              $rootWizard.find('.bar').css({
                width: $percent + '%'
              }); // If it's the last tab then hide the last button and show the finish instead

              if ($current === 1) {
                $rootWizard.find('.navigation .prev').hide();
              } else {
                $rootWizard.find('.navigation .prev').show();
              }

              if ($current >= $total) {
                $rootWizard.find('.navigation .next').hide();
                $rootWizard.find('.navigation .finish').show();
              } else {
                $rootWizard.find('.navigation .next').show();
                $rootWizard.find('.navigation .finish').hide();
              }
            },
            onTabChange: function onTabChange(tab, navigation, index) {// return false;
            }
          });
        }
      }
    }
  }, {
    key: "htmlEditor",
    value: function htmlEditor($element) {
      if ($element.length) {
        $element.summernote({
          height: 150
        });
      }
    }
  }, {
    key: "inputSlider",
    value: function inputSlider($element) {
      if ($element.length) {
        $element.each(function () {
          var isStart = $(this).data('is-start');
          $(this).noUiSlider({
            start: isStart,
            range: {
              'min': 0,
              'max': 100
            }
          });
        });
      }
    }
  }, {
    key: "inputMask",
    value: function inputMask($element) {
      //Input Mask
      if ($element.length) {
        $element.mask();
      }
    }
  }, {
    key: "tagSelect",
    value: function tagSelect($element) {
      //Tag Select
      if ($element.length) {
        $element.chosen({
          width: '100%',
          allow_single_deselect: true
        });
      }
    }
  }, {
    key: "textareaAutosize",
    value: function textareaAutosize($element) {
      //Auto Height Textarea
      if ($element.length) {
        $element.autosize();
      }
    } //add additional elements

  }]);

  return ApiForms;
}();

var _addSubForm = function _addSubForm() {
  $('.add-template').on('click', function (e) {
    e.preventDefault();
    var template = $(this).attr('template');
    var href = $(this).attr('href');
    $('#' + template).tmpl().appendTo(href);
  });
  $('.subform').on('click', '.delete-template', function (e) {
    e.preventDefault();
    $(this).parent().parent().remove();
  });
};

var _inputSliderValue = function _inputSliderValue($element) {
  if ($element.length) {
    $element.noUiSlider({
      start: [45, 80],
      connect: true,
      direction: 'rtl',
      behaviour: 'tap-drag',
      range: {
        'min': 0,
        'max': 100
      }
    });
    $element.Link('lower').to($('#value-lower'));
    $element.Link('upper').to($('#value-upper'), 'html');
  }
};

var _inputSliderRange = function _inputSliderRange($element) {
  if ($element.length) {
    $element.noUiSlider({
      start: [30, 60],
      range: {
        'min': 0,
        'max': 100
      },
      connect: true
    });
  }
};

var _addDecorativeElements = function _addDecorativeElements() {
  //Add blue animated border and remove with condition when focus and blur
  if ($('.fg-line')[0]) {
    var $body = $('body');
    $body.on('focus', '.form-control', function () {
      $(this).closest('.fg-line').addClass('fg-toggled');
    });
    $body.on('blur', '.form-control', function () {
      var p = $(this).closest('.form-group');
      var i = p.find('.form-control').val();

      if (p.hasClass('fg-float')) {
        if (i.length === 0) {
          $(this).closest('.fg-line').removeClass('fg-toggled');
        }
      } else {
        $(this).closest('.fg-line').removeClass('fg-toggled');
      }
    });
  } //Add blue border for pre-valued fg-flot text fields


  if ($('.fg-float')[0]) {
    $('.fg-float .form-control').each(function () {
      var i = $(this).val();

      if (i.length !== 0) {
        $(this).closest('.fg-line').addClass('fg-toggled');
      }
    });
  }
};
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
Created by marcin on 2015-09-28 - 12:05.
*/
var ApiLogin = /*#__PURE__*/function () {
  function ApiLogin() {
    _classCallCheck(this, ApiLogin);
  }

  _createClass(ApiLogin, null, [{
    key: "init",
    value: function init() {
      //Login
      if ($('.login-content')[0]) {
        //Add class to HTML. This is used to center align the login box
        $('html').addClass('login-content');
        $('body').on('click', '.login-navigation > li', function () {
          var z = $(this).data('block');
          var t = $(this).closest('.lc-block');
          t.removeClass('toggled');
          setTimeout(function () {
            $(z).addClass('toggled');
          });
        });
      }
    }
  }]);

  return ApiLogin;
}();
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classStaticPrivateMethodGet(receiver, classConstructor, method) { if (receiver !== classConstructor) { throw new TypeError("Private static access of wrong provenance"); } return method; }

/*
Created by marcin on 2015-09-28 - 11:53.

Dostępne metody:
----------------
ApiNotification.init()
    odpala eventy dla elementów z atrybutem [data-toast] i [data-dialog]. Dla elementów data-toast odpalają metodę notify.
    Dla elementów data-dialog odpalają funkcję dialog.

ApiNotification.dialog(title, message, type, cancelButton, confirmButtonColor, confirmButtonText, cancelButtonText, afterConfirmTitle, afterConfirmMessage, redirect)
    Pokazuje okienko typu dialog

ApiNotification.notify(from, align, icon, type, animIn, animOut, message, title)
    Pokazuje element notify w prawym górnym rogu

*/
var ApiNotification = /*#__PURE__*/function () {
  function ApiNotification() {
    _classCallCheck(this, ApiNotification);
  }

  _createClass(ApiNotification, null, [{
    key: "init",
    value: function init() {
      ApiNotification.bindEvents();

      _classStaticPrivateMethodGet(ApiNotification, ApiNotification, _autoToasts).call(ApiNotification);
    }
  }, {
    key: "dialog",
    value: function dialog(_title, message, _type, cancelButton, _confirmButtonColor, _confirmButtonText, _cancelButtonText, afterConfirmTitle, afterConfirmMessage, redirect) {
      if ($.isFunction(swal)) {
        swal({
          title: _title,
          text: message,
          type: _type,
          showCancelButton: cancelButton,
          confirmButtonColor: _confirmButtonColor,
          confirmButtonText: _confirmButtonText,
          cancelButtonText: _cancelButtonText,
          closeOnConfirm: false,
          closeOnCancel: true
        }, function (isConfirm) {
          if (redirect === 0 || typeof redirect === 'undefined') {
            if (isConfirm) {
              swal(afterConfirmTitle, afterConfirmMessage, "success");
            }
          } else {
            if (isConfirm) {
              location.href = redirect;
            }
          }
        });
      } else {
        console.log('Swal plugin not include -> http://t4t5.github.io/sweetalert/');
        return false;
      }
    }
  }, {
    key: "notify",
    value: function notify(options, align, icon, type, animIn, animOut, _message, _title, _delay, _timer) {
      var from;

      if (_typeof(options) === 'object') {
        from = options === null || options === void 0 ? void 0 : options.from;
        align = options === null || options === void 0 ? void 0 : options.align;
        icon = options === null || options === void 0 ? void 0 : options.icon;
        type = options === null || options === void 0 ? void 0 : options.type;
        animIn = options === null || options === void 0 ? void 0 : options.animIn;
        animOut = options === null || options === void 0 ? void 0 : options.animOut;
        _message = options === null || options === void 0 ? void 0 : options._message;
        _title = options === null || options === void 0 ? void 0 : options._title;
        _delay = options === null || options === void 0 ? void 0 : options._delay;
        _timer = options === null || options === void 0 ? void 0 : options._timer;
      } else {
        from = options;
      }

      if ($.isFunction($.growl)) {
        $.growl({
          icon: icon,
          title: _title,
          message: _message,
          url: ''
        }, {
          element: 'body',
          type: type,
          allow_dismiss: true,
          placement: {
            from: from,
            align: align
          },
          offset: {
            x: 20,
            y: 85
          },
          spacing: 10,
          z_index: 1031,
          delay: typeof _delay === 'undefined' ? 3500 : _delay,
          timer: typeof _timer === 'undefined' ? 1000 : _timer,
          url_target: '_blank',
          mouse_over: false,
          animate: {
            enter: animIn,
            exit: animOut
          },
          icon_type: 'class',
          template: '<div data-growl="container" class="alert" role="alert">' + '<button type="button" class="close" data-growl="dismiss">' + '<span aria-hidden="true">&times;</span>' + '<span class="sr-only">Close</span>' + '</button>' + '<span data-growl="icon"></span>' + '<span data-growl="title"></span>' + '<span data-growl="message"></span>' + '<a href="#" data-growl="url"></a>' + '</div>'
        });
      } else {
        console.log('Growl plugin not include -> https://github.com/ifightcrime/bootstrap-growl/');
        return false;
      }
    }
  }, {
    key: "alert",
    value: function alert(_title, message, _type, cancelButton, _confirmButtonColor, _confirmButtonText, _cancelButtonText) {
      if ($.isFunction(swal)) {
        swal({
          title: _title,
          text: message,
          type: _type,
          showCancelButton: cancelButton,
          confirmButtonColor: _confirmButtonColor,
          confirmButtonText: _confirmButtonText,
          cancelButtonText: _cancelButtonText,
          closeOnConfirm: true,
          closeOnCancel: true
        });
      } else {
        console.log('Swal plugin not include -> http://t4t5.github.io/sweetalert/');
        return false;
      }
    }
  }, {
    key: "bindEvents",
    value: function bindEvents() {
      //toast
      $('[data-toast]').click(function (e) {
        e.preventDefault();
        var msg;
        var nFrom = $(this).attr('data-from');
        var nAlign = $(this).attr('data-align');
        var nIcons = $(this).attr('data-icon');
        var nType = $(this).attr('data-type');
        var nAnimIn = $(this).attr('data-animation-in');
        var nAnimOut = $(this).attr('data-animation-out');
        var ttl = $(this).attr('data-title');
        msg = $(this).attr('data-message');

        if (msg === 0 || typeof msg === 'undefined') {
          msg = 'Akcja zakończona sukcesem';
        }

        ApiNotification.notify(nFrom, nAlign, nIcons, nType, nAnimIn, nAnimOut, msg, ttl);
      }); //dialog

      $('[data-dialog]').click(function (e) {
        e.preventDefault();

        var _title = $(this).attr('data-title');

        var message = $(this).attr('data-message');

        var _type = $(this).attr('data-type');

        var cancelButton = $(this).attr('data-cancel-button');

        var _confirmButtonColor = $(this).attr('data-confirm-button-color');

        var _confirmButtonText = $(this).attr('data-confirm-button-text');

        var _cancelButtonText = $(this).attr('data-cancel-button-text');

        var afterConfirmTitle = $(this).attr('data-after-confirm-title');
        var afterConfirmMessage = $(this).attr('data-after-confirm-message');
        var redirect = $(this).attr('data-redirect');

        if (_title === 0 || typeof _title === 'undefined') {
          _title = "Czy na pewno chcesz wykonać akcję?";
        }

        if (afterConfirmTitle === 0 || typeof afterConfirmTitle === 'undefined') {
          afterConfirmTitle = "Sukces!";
        }

        if (afterConfirmMessage === 0 || typeof afterConfirmMessage === 'undefined') {
          afterConfirmMessage = "";
        }

        ApiNotification.dialog(_title, message, _type, cancelButton, _confirmButtonColor, _confirmButtonText, _cancelButtonText, afterConfirmTitle, afterConfirmMessage, redirect);
      }); //alert

      $('[data-alert]').click(function (e) {
        e.preventDefault();

        var _title = $(this).attr('data-title');

        var message = $(this).attr('data-message');

        var _type = $(this).attr('data-type');

        var cancelButton = $(this).attr('data-cancel-button');

        var _confirmButtonColor = $(this).attr('data-confirm-button-color');

        var _confirmButtonText = $(this).attr('data-confirm-button-text');

        var _cancelButtonText = $(this).attr('data-cancel-button-text');

        if (_title === 0 || typeof _title === 'undefined') {
          _title = "Czy na pewno chcesz wykonać akcję?";
        }

        ApiNotification.alert(_title, message, _type, cancelButton, _confirmButtonColor, _confirmButtonText, _cancelButtonText);
      });
    }
  }]);

  return ApiNotification;
}();

var _autoToasts = function _autoToasts() {
  $('.toasts > *').each(function () {
    var msg = $(this).html();
    var ttl = '';
    var nFrom = $(this).attr('data-from');
    var nAlign = $(this).attr('data-align');
    var nIcons = $(this).attr('data-icon');
    var nType = 'success';
    var nAnimIn = $(this).attr('data-animation-in');
    var nAnimOut = $(this).attr('data-animation-out');
    ApiNotification.notify(nFrom, nAlign, nIcons, nType, nAnimIn, nAnimOut, msg, ttl);
  });
};
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classStaticPrivateMethodGet(receiver, classConstructor, method) { if (receiver !== classConstructor) { throw new TypeError("Private static access of wrong provenance"); } return method; }

/*
Zarządzanie usługami w edycji firmy. Dodaje obsługę accordiona. Po zaznaczeniu checkboxa w tytule panelu accordiona
rozwija dany panel. Gdy checkbox jest odznaczony, panel jest ukryty.

Dostępne metody:
ApiServicesAccordion.init() - odpalenie skryptu
*/
var ApiServicesAccordion = /*#__PURE__*/function () {
  function ApiServicesAccordion() {
    _classCallCheck(this, ApiServicesAccordion);
  }

  _createClass(ApiServicesAccordion, null, [{
    key: "init",
    value: function init() {
      _classStaticPrivateMethodGet(ApiServicesAccordion, ApiServicesAccordion, _initAccordion).call(ApiServicesAccordion);

      _classStaticPrivateMethodGet(ApiServicesAccordion, ApiServicesAccordion, _validation).call(ApiServicesAccordion);
    }
  }]);

  return ApiServicesAccordion;
}();

var _validation = function _validation() {
  var $list = $('#ddosNotificationEmailsList');
  var mailReg = /^[0-9a-z_.-]+@[0-9a-z.-]+\.[a-z]{2,3}$/i;
  var $serviceOne = $('#serviceOne'); //walidacja tylko jak jest

  $('#servicesConfig').on('submit', function (e) {
    if ($serviceOne.prev().find('input:checkbox:checked').length) {
      var hasBadEmails = false;
      $list.find('input:text').each(function () {
        var $this = $(this);

        if (!mailReg.test($this.val())) {
          $(this).parent().parent().addClass('has-error');
          hasBadEmails = true;
        } else {
          $(this).parent().parent().removeClass('has-error');
        }
      });

      if (hasBadEmails) {
        e.preventDefault();
        $('html, body').animate({
          scrollTop: $serviceOne.parent().parent().offset().top - 70
        }, 1000);
      }
    }
  });
  $list.find('input:text').on('blur', function () {
    var $this = $(this);

    if (!mailReg.test($this.val())) {
      $(this).parent().parent().addClass('has-error');
    } else {
      $(this).parent().parent().removeClass('has-error');
    }
  });
};

var _initAccordion = function _initAccordion() {
  $('.accordion .panel-title input[type=checkbox]').each(function () {
    if ($(this).is(':checked')) {
      $(this).closest('.panel-heading').parent().find('.panel-collapse').addClass('in');
    } else {
      $(this).closest('.panel-heading').parent().find('.panel-collapse').removeClass('in');
    } // noinspection JSUnusedLocalSymbols


    $(this).on('click', function (e) {
      $(this).closest('.panel').find('.panel-collapse').collapse('toggle');
    });
  });
};
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/*
Dodaje obsługę wyboru autentykacji użytkownika w ustawieniach użytkownika

Metody:
userAuthenticateConfig.init() - odpala skrypt
*/
var ApiUserAuthenticateConfig = /*#__PURE__*/function () {
  function ApiUserAuthenticateConfig() {
    _classCallCheck(this, ApiUserAuthenticateConfig);
  }

  _createClass(ApiUserAuthenticateConfig, null, [{
    key: "init",
    value: function init() {
      $('.google-radio-list input:radio').on('click', function () {
        if ($(this).val() === 'none') {
          $('.authorization-type1-info').show();
          $('.authorization-type2-info').hide();
          $('.authorization-type3-info').hide();
        }

        if ($(this).val() === 'email') {
          $('.authorization-type1-info').hide();
          $('.authorization-type2-info').show();
          $('.authorization-type3-info').hide();
        }

        if ($(this).val() === 'google') {
          $('.authorization-type1-info').hide();
          $('.authorization-type2-info').hide();
          $('.authorization-type3-info').show();
        }
      });
      $('.google-radio-list input').each(function () {
        if ($(this).is(':checked') && $(this).val() === 'none') {
          $('.authorization-type1-info').show();
          $('.authorization-type2-info').hide();
          $('.authorization-type3-info').hide();
        }

        if ($(this).is(':checked') && $(this).val() === 'email') {
          $('.authorization-type1-info').hide();
          $('.authorization-type2-info').show();
          $('.authorization-type3-info').hide();
        }

        if ($(this).is(':checked') && $(this).val() === 'google') {
          $('.authorization-type1-info').hide();
          $('.authorization-type2-info').hide();
          $('.authorization-type3-info').show();
        }
      });
    }
  }]);

  return ApiUserAuthenticateConfig;
}();
"use strict";

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DEFAULT_PAGE_SIZE = 25;

function coerceBooleanProperty(prop) {
  return prop === '' || prop === 'on' || prop === 'yes' || prop === 'true' || prop === '1' || typeof prop === 'number' && prop !== 0 || prop === true;
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(obj, event, callback) {
    _classCallCheck(this, Subscription);

    this._obj = obj;
    this._event = event;
    this._callback = callback;
  }

  _createClass(Subscription, [{
    key: "unsubscribe",
    value: function unsubscribe() {
      if (this._obj && this._event && this._callback) {
        this._obj.removeEventListener(this._event, this._callback);
      }

      this._obj = void 0;
      this._event = void 0;
      this._callback = void 0;
    }
  }]);

  return Subscription;
}();

var Subscriptions = /*#__PURE__*/function () {
  function Subscriptions() {
    _classCallCheck(this, Subscriptions);

    this._data = [];
  }

  _createClass(Subscriptions, [{
    key: "add",
    value: function add(subscription) {
      if (_typeof(subscription) === 'object' && subscription instanceof Subscription) {
        this._data.push(subscription);
      }
    }
  }, {
    key: "unsubscribe",
    value: function unsubscribe() {
      var _iterator = _createForOfIteratorHelper(this._data),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var s = _step.value;
          s.unsubscribe();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._data = [];
    }
  }]);

  return Subscriptions;
}();

var oldAddEventListener = HTMLElement.prototype.addEventListener;

HTMLElement.prototype.addEventListener = function (event, listener, options) {
  oldAddEventListener.call(this, event, listener, options);
  return new Subscription(this, event, listener);
};

var Sort = /*#__PURE__*/function () {
  function Sort() {
    _classCallCheck(this, Sort);

    this.data = [];
  }

  _createClass(Sort, [{
    key: "push",
    value: function push(field, value) {
      this.data = this.data.filter(function (obj) {
        return obj.field !== field;
      });

      if (value === 'asc' || value === 'desc') {
        this.data.push({
          field: field,
          value: value
        });
      }
    }
  }, {
    key: "toString",
    value: function toString() {
      var tmp = [];

      var _iterator2 = _createForOfIteratorHelper(this.data),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var obj = _step2.value;
          tmp.push("".concat(encodeURIComponent(obj.field), "=").concat(encodeURIComponent(obj.value)));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return tmp.join('&');
    }
  }]);

  return Sort;
}();

var DataTable = /*#__PURE__*/function (_HTMLElement) {
  _inherits(DataTable, _HTMLElement);

  var _super = _createSuper(DataTable);

  _createClass(DataTable, [{
    key: "selectable",
    get: function get() {
      return coerceBooleanProperty(this.getAttribute('selectable'));
    }
  }]);

  function DataTable() {
    var _this;

    _classCallCheck(this, DataTable);

    _this = _super.call(this);
    _this._paginator = null;
    _this._inputTimeout = null;
    _this._sort = new Sort();
    _this._observer = new MutationObserver(_this.onMutation.bind(_assertThisInitialized(_this)));
    _this._shadow = _this.attachShadow({
      mode: 'closed'
    });
    _this._rows = [];
    _this._selection = [];
    _this._onPageSubscription = void 0;
    _this._onSizeSubscription = void 0;

    var style = _this._shadow.appendChild(document.createElement('link'));

    style.rel = 'stylesheet';
    style.href = "/data-table.css?t=".concat(+Date.now());
    return _this;
  }

  _createClass(DataTable, [{
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.table = this._shadow.appendChild(document.createElement('table'));
                this.loader = this._shadow.appendChild(document.createElement('div'));
                this.table.style.width = '100%';
                this.table.classList.add('data-table');
                this.loader.classList.add('data-table-loader');
                this.loader.appendChild(document.createElement('div'));
                setTimeout(function () {
                  // ograniczenie niepotrzebnego odpalania wielokrotnie podczas budowania elementu...
                  _this2._observer.observe(_this2, {
                    attributes: true,
                    childList: true,
                    subtree: true
                  });

                  _this2.onMutation();

                  _this2.load();
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this._observer.disconnect();

      this.table.remove();
    }
  }, {
    key: "onPage",
    value: function () {
      var _onPage = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.load();

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function onPage() {
        return _onPage.apply(this, arguments);
      }

      return onPage;
    }()
  }, {
    key: "onSize",
    value: function () {
      var _onSize = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.load();

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function onSize() {
        return _onSize.apply(this, arguments);
      }

      return onSize;
    }()
  }, {
    key: "onMutation",
    value: function onMutation() {
      var _this3 = this;

      if (this._onPageSubscription) {
        this._onPageSubscription.unsubscribe();

        this._onPageSubscription = void 0;
      }

      if (this._onSizeSubscription) {
        this._onSizeSubscription.unsubscribe();

        this._onSizeSubscription = void 0;
      }

      if (this._paginator = this.querySelector('data-table-paginator')) {
        this._onPageSubscription = this._paginator.addEventListener('page', this.onPage.bind(this));
        this._onSizeSubscription = this._paginator.addEventListener('size', this.onSize.bind(this));
      } //clear table


      while (this.table.firstChild) {
        this.table.removeChild(this.table.firstChild);
      }

      var shadowPaginator = this._shadow.querySelector('div.data-table-paginator-container');

      if (!this._paginator && shadowPaginator) {
        shadowPaginator.parentElement.removeChild(shadowPaginator);
      } else if (this._paginator && !shadowPaginator) {
        if (this._paginator._element && this._paginator._element.parentElement) {
          this._paginator._element.parentElement.removeChild(this._paginator._element);
        }

        this._shadow.appendChild(this._paginator._element);
      }

      var headers = this.querySelectorAll('data-table-header');
      var thead = this.table.appendChild(document.createElement('thead'));
      var theadRow = thead.appendChild(document.createElement('tr'));
      var tbody = this.table.appendChild(document.createElement('tbody'));
      var filterable = false;

      if (this.selectable) {
        var selectAllTh = theadRow.appendChild(document.createElement('th'));
        this.selectAllCheckbox = selectAllTh.appendChild(document.createElement('input'));
        this.selectAllCheckbox.type = 'checkbox';
        this.selectAllCheckbox.addEventListener('change', function (e) {
          var _iterator3 = _createForOfIteratorHelper(tbody.querySelectorAll('input[data-type="select-row"]')),
              _step3;

          try {
            var _loop = function _loop() {
              var checkbox = _step3.value;
              checkbox.checked = _this3.selectAllCheckbox.checked;
              var rowId = checkbox.getAttribute('data-id');
              var tr = checkbox.closest('tr');

              if (rowId === void 0) {
                console.error('Zbiór danych nie posiada pola z identyfikatorem.');
                return "continue";
              }

              if (_this3.selectAllCheckbox.checked) {
                if (!_this3._selection.includes(rowId)) {
                  tr.classList.add('selected');

                  _this3._selection.push(rowId);
                }
              } else {
                if (_this3._selection.includes(rowId)) {
                  tr.classList.remove('selected');
                  _this3._selection = _this3._selection.filter(function (item) {
                    return item !== rowId;
                  });
                }
              }
            };

            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _ret = _loop();

              if (_ret === "continue") continue;
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }

          _this3.selectionChanged();
        });
      }

      var _iterator4 = _createForOfIteratorHelper(headers),
          _step4;

      try {
        var _loop2 = function _loop2() {
          var header = _step4.value;
          if (!header.visible) return "continue";
          var th = theadRow.appendChild(document.createElement('th'));
          th.innerText = th.textContent = header.label;

          if (header.filterable) {
            filterable = true;
          }

          if (header.sortable) {
            var sorter = th.appendChild(document.createElement('data-table-internal-sorter'));
            sorter.addEventListener('click', /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(e) {
                return regeneratorRuntime.wrap(function _callee5$(_context5) {
                  while (1) {
                    switch (_context5.prev = _context5.next) {
                      case 0:
                        e.preventDefault();
                        sorter.next();
                        _context5.next = 4;
                        return _this3.onSort(header, sorter);

                      case 4:
                      case "end":
                        return _context5.stop();
                    }
                  }
                }, _callee5);
              }));

              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }());
          }
        };

        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _ret2 = _loop2();

          if (_ret2 === "continue") continue;
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      if (filterable) {
        var filtersRow = thead.appendChild(document.createElement('tr'));

        if (this.selectable) {
          filtersRow.appendChild(document.createElement('th'));
        }

        var _iterator5 = _createForOfIteratorHelper(headers),
            _step5;

        try {
          for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
            var header = _step5.value;
            if (!header.visible) continue;
            var filterCell = filtersRow.appendChild(document.createElement('th'));

            if (!header.filterable) {
              continue;
            }

            var filter = header.filter;
            var filterElement = (filter || {}).element;

            if (filter && filterElement) {
              if (filterElement.parentElement) {
                filterElement.parentElement.removeChild(filter);
              }

              filterCell.appendChild(filterElement);
              filter.addEventListener('filter', /*#__PURE__*/function () {
                var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(e) {
                  return regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) {
                      switch (_context4.prev = _context4.next) {
                        case 0:
                          e.preventDefault();
                          e.stopPropagation();
                          _context4.next = 4;
                          return _this3.onFilter();

                        case 4:
                        case "end":
                          return _context4.stop();
                      }
                    }
                  }, _callee4);
                }));

                return function (_x) {
                  return _ref.apply(this, arguments);
                };
              }());
            }
          }
        } catch (err) {
          _iterator5.e(err);
        } finally {
          _iterator5.f();
        }
      }

      this.render(headers, tbody);
    }
  }, {
    key: "onFilter",
    value: function () {
      var _onFilter = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var _this4 = this;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (this._inputTimeout) {
                  clearTimeout(this._inputTimeout);
                }

                this._inputTimeout = setTimeout(function () {
                  _this4._inputTimeout = null;

                  _this4.load(true);
                }, 500);

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function onFilter() {
        return _onFilter.apply(this, arguments);
      }

      return onFilter;
    }()
  }, {
    key: "onSort",
    value: function () {
      var _onSort = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(header, sorter) {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                this._sort.push(header.field, sorter.direction);

                _context7.next = 3;
                return this.load();

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function onSort(_x3, _x4) {
        return _onSort.apply(this, arguments);
      }

      return onSort;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(resetPaginator) {
        var payload, response, data;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                if (this._inputTimeout) {
                  clearTimeout(this._inputTimeout);
                  this._inputTimeout = null;
                }

                this.table.classList.remove('error');
                this.table.classList.add('loading');
                this.loader.classList.add('loading');

                if (this.selectAllCheckbox) {
                  this.selectAllCheckbox.checked = false;
                  this._selection = [];
                  this.dispatchEvent(new CustomEvent('selection-changed', {
                    detail: this._selection
                  }));
                }

                if (this._paginator) {
                  this._paginator.disabled = true;
                }

                payload = {
                  sort: this._sort.data,
                  filters: this._filters
                };

                if (this._paginator) {
                  payload.page = !resetPaginator ? this._paginator.page : 1;
                  payload.size = this._paginator.size;
                }

                _context8.prev = 8;
                _context8.next = 11;
                return fetch(this.getAttribute('url'), {
                  method: 'POST',
                  headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify(payload)
                });

              case 11:
                response = _context8.sent;
                _context8.next = 14;
                return response.json();

              case 14:
                data = _context8.sent;
                this._rows = data.rows || [];

                if (this._paginator) {
                  // noinspection JSUnresolvedVariable
                  this._paginator.update(data.total_rows || 0, !!resetPaginator);
                }

                _context8.next = 25;
                break;

              case 19:
                _context8.prev = 19;
                _context8.t0 = _context8["catch"](8);
                console.error(_context8.t0);
                this.table.classList.add('error');
                this._rows = [];

                if (this._paginator) {
                  this._paginator.total = 0;
                }

              case 25:
                _context8.prev = 25;
                this.render();
                this.table.classList.remove('loading');
                this.loader.classList.remove('loading');

                if (this._paginator) {
                  this._paginator.disabled = false;
                }

                this.dispatchEvent(new CustomEvent('load', {
                  detail: this._rows,
                  bubbles: true
                }));
                return _context8.finish(25);

              case 32:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[8, 19, 25, 32]]);
      }));

      function load(_x5) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: "selectionChanged",
    value: function selectionChanged() {
      if (this.selectAllCheckbox) {
        this.selectAllCheckbox.checked = this._rows.length === this._selection.length;
      }

      this.dispatchEvent(new CustomEvent('selection-changed', {
        detail: this._selection
      }));
    }
  }, {
    key: "render",
    value: function render(headers, tbody) {
      var _this5 = this;

      headers = headers || this.querySelectorAll('data-table-header');
      tbody = tbody || this.table.querySelector('tbody');

      while (tbody.firstChild) {
        tbody.removeChild(tbody.firstChild);
      }

      if (this._rows.length > 0) {
        var _iterator6 = _createForOfIteratorHelper(this._rows),
            _step6;

        try {
          var _loop3 = function _loop3() {
            var row = _step6.value;
            var tr = tbody.appendChild(document.createElement('tr'));

            if (_this5.selectable) {
              var selectTd = tr.appendChild(document.createElement('td'));
              var selectCheckbox = selectTd.appendChild(document.createElement('input'));
              selectCheckbox.type = 'checkbox';
              selectCheckbox.setAttribute('data-type', 'select-row');
              selectCheckbox.setAttribute('data-id', row.id); // noinspection JSUnusedLocalSymbols

              selectCheckbox.addEventListener('change', function (e) {
                if (row.id === void 0) {
                  console.error('Zbiór danych nie posiada pola z identyfikatorem.');
                  return;
                }

                if (!_this5._selection.includes(row.id)) {
                  tr.classList.add('selected');

                  _this5._selection.push(row.id);
                } else {
                  tr.classList.remove('selected');
                  _this5._selection = _this5._selection.filter(function (item) {
                    return item !== row.id;
                  });
                }

                _this5.selectionChanged();
              });
            }

            var _iterator7 = _createForOfIteratorHelper(headers),
                _step7;

            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var header = _step7.value;
                if (!header.visible) continue;
                var td = tr.appendChild(document.createElement('td'));
                var value = header.renderer.render(row[header.field], row);

                if (typeof value === "number" || typeof value === "string") {
                  td.textContent = value;
                } else if (typeof value === "boolean") {
                  td.textContent = value ? "Tak" : "Nie";
                } else if (_typeof(value) === "object" && value instanceof HTMLElement) {
                  td.appendChild(value);
                } else {
                  td.textContent = "-";
                }
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          };

          for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
            _loop3();
          }
        } catch (err) {
          _iterator6.e(err);
        } finally {
          _iterator6.f();
        }
      } else {
        var headersCount = Array.from(headers).filter(function (header) {
          return !!header.visible;
        }).length;
        var tr = tbody.appendChild(document.createElement('tr'));
        var td = tr.appendChild(document.createElement('td'));
        td.colSpan = headersCount;
        td.textContent = 'Brak danych.';
        td.style.textAlign = 'center';
      }

      this.dispatchEvent(new CustomEvent('render'));
    }
  }, {
    key: "_filters",
    get: function get() {
      var headers = this.querySelectorAll('data-table-header');
      var filters = {};

      var _iterator8 = _createForOfIteratorHelper(headers),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var header = _step8.value;

          if (header.filterable) {
            var value = header.filter.value;

            if (value !== undefined) {
              filters[header.field] = value;
            }
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }

      return filters;
    }
  }]);

  return DataTable;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var DataTableHeader = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(DataTableHeader, _HTMLElement2);

  var _super2 = _createSuper(DataTableHeader);

  function DataTableHeader() {
    var _this6;

    _classCallCheck(this, DataTableHeader);

    _this6 = _super2.call(this);
    _this6._defaultFilter = document.createElement('data-table-filter-default');
    _this6._defaultRenderer = document.createElement('data-table-renderer-default');
    return _this6;
  }

  _createClass(DataTableHeader, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.style.display = 'none';
      this.hidden = true;
      this.appendChild(this._defaultFilter);
      this.appendChild(this._defaultRenderer);
    }
  }, {
    key: "_findFilter",
    value: function _findFilter() {
      for (var _i = 0, _Array$from = Array.from(this.children); _i < _Array$from.length; _i++) {
        var child = _Array$from[_i];

        if (child instanceof DataTableCustomFilter && child !== this._defaultFilter) {
          return child;
        }
      }

      return void 0;
    }
  }, {
    key: "_findRenderer",
    value: function _findRenderer() {
      for (var _i2 = 0, _Array$from2 = Array.from(this.children); _i2 < _Array$from2.length; _i2++) {
        var child = _Array$from2[_i2];

        if (child instanceof DataTableCustomRenderer && child !== this._defaultRenderer) {
          return child;
        }
      }

      return void 0;
    }
  }, {
    key: "filterable",
    get: function get() {
      return coerceBooleanProperty(this.getAttribute('filterable')) || this._findFilter() !== void 0;
    }
  }, {
    key: "filter",
    get: function get() {
      return this._findFilter() || this._defaultFilter;
    }
  }, {
    key: "sortable",
    get: function get() {
      return coerceBooleanProperty(this.getAttribute('sortable'));
    }
  }, {
    key: "field",
    get: function get() {
      return this.getAttribute('field');
    }
  }, {
    key: "visible",
    get: function get() {
      var attr = this.getAttribute('visible');
      return attr === null || attr === undefined || coerceBooleanProperty(attr);
    }
  }, {
    key: "label",
    get: function get() {
      var filtered = Array.from(this.childNodes).filter(function (v) {
        return v.nodeName === '#text' || v.nodeType === Node.TEXT_NODE;
      }).filter(function (v) {
        return v.textContent && v.textContent.trim().length > 0;
      });
      var txt = filtered.length > 0 ? filtered[0].textContent : '';
      return txt.trim();
    }
  }, {
    key: "renderer",
    get: function get() {
      return this._findRenderer() || this._defaultRenderer;
    }
  }]);

  return DataTableHeader;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var DataTableSorter = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(DataTableSorter, _HTMLElement3);

  var _super3 = _createSuper(DataTableSorter);

  function DataTableSorter() {
    var _this7;

    _classCallCheck(this, DataTableSorter);

    _this7 = _super3.call(this);
    _this7.up = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    _this7.down = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

    _this7.up.setAttribute('width', '10');

    _this7.up.setAttribute('height', '15');

    _this7.up.setAttribute('viewBox', '0 0 10 15');

    _this7.down.setAttribute('width', '10');

    _this7.down.setAttribute('height', '15');

    _this7.down.setAttribute('viewBox', '0 0 10 15');

    var pathUp = _this7.up.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'path'));

    pathUp.setAttribute('d', 'm4.99942,14.57955l-4.72013,-5.31014l3.5401,0l0,-8.85024l2.36006,0l0,8.85024l3.5401,0l-4.72013,5.31014z');

    var pathDown = _this7.down.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'path'));

    pathDown.setAttribute('d', pathUp.getAttribute('d'));
    pathDown.setAttribute('transform', 'rotate(180, 5, 7.49805)');
    return _this7;
  }

  _createClass(DataTableSorter, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.appendChild(this.up);
      this.appendChild(this.down);
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.removeChild(this.up);
      this.removeChild(this.down);
    }
  }, {
    key: "next",
    value: function next() {
      var dir = this.direction;

      switch (dir) {
        case 'asc':
          this.classList.replace('asc', 'desc');
          break;

        case 'desc':
          this.classList.remove('desc');
          break;

        default:
          this.classList.add('asc');
          break;
      }
    }
  }, {
    key: "direction",
    get: function get() {
      if (this.classList.contains('asc')) {
        return 'asc';
      } else if (this.classList.contains('desc')) {
        return 'desc';
      }

      return void 0;
    }
  }]);

  return DataTableSorter;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var DataTablePaginator = /*#__PURE__*/function (_HTMLElement4) {
  _inherits(DataTablePaginator, _HTMLElement4);

  var _super4 = _createSuper(DataTablePaginator);

  _createClass(DataTablePaginator, [{
    key: "disabled",
    get: function get() {
      return this._disabled;
    },
    set: function set(d) {
      this._disabled = !!d;
      this.render();
    }
  }, {
    key: "sizeOptions",
    get: function get() {
      var attr = this.getAttribute('sizes') || '10,25,50,100,200';
      return attr.split(/,|;|\s+/);
    }
  }]);

  function DataTablePaginator() {
    var _this8;

    _classCallCheck(this, DataTablePaginator);

    _this8 = _super4.call(this);
    _this8._totalRecords = 0;
    _this8._page = 1;
    _this8._size = 25;
    _this8._disabled = false;
    _this8._container = document.createElement('div');

    _this8._container.classList.add('data-table-paginator-container');

    _this8._container.style.display = 'flex';
    _this8._container.style.justifyContent = 'end';
    _this8._container.style.marginTop = '10px';

    var changeSizeLabel = _this8._container.appendChild(document.createElement('span'));

    changeSizeLabel.textContent = 'Rekordów na stronę:';

    var selectContainer = _this8._container.appendChild(document.createElement('div'));

    selectContainer.classList.add('data-table-paginator-select-container');
    var selectLabel = selectContainer.appendChild(document.createElement('label'));
    _this8._sizesSelect = selectLabel.appendChild(document.createElement('select'));
    _this8._stats = _this8._container.appendChild(document.createElement('span'));
    _this8._first = _this8._container.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'svg'));
    _this8._prev = _this8._container.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'svg'));
    _this8._next = _this8._container.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'svg'));
    _this8._last = _this8._container.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'svg'));

    for (var _i3 = 0, _arr = [_this8._first, _this8._prev, _this8._next, _this8._last]; _i3 < _arr.length; _i3++) {
      var el = _arr[_i3];
      el.setAttribute('viewBox', '0 0 24 24');
      el.style.width = el.style.height = '24px';
    }

    var title = _this8._first.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'title'));

    title.textContent = 'Pierwsza strona';
    title = _this8._prev.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'title'));
    title.textContent = 'Poprzednia strona';
    title = _this8._next.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'title'));
    title.textContent = 'Następna strona';
    title = _this8._last.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'title'));
    title.textContent = 'Ostatnia strona';

    var path = _this8._first.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'path'));

    path.setAttribute('d', "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z");
    path = _this8._prev.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'path'));
    path.setAttribute('d', "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z");
    path = _this8._next.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'path'));
    path.setAttribute('d', "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z");
    path = _this8._last.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'path'));
    path.setAttribute('d', "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z");

    _this8._first.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this8.first();
    });

    _this8._next.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this8.next();
    });

    _this8._prev.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this8.prev();
    });

    _this8._last.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this8.last();
    });

    _this8._sizesSelect.addEventListener('change', function (e) {
      e.preventDefault();
      e.stopPropagation();
      _this8._size = +_this8._sizesSelect.value;

      _this8.dispatchEvent(new CustomEvent('size', {
        detail: _this8._sizesSelect.value
      }));
    });

    _this8.render();

    return _this8;
  }

  _createClass(DataTablePaginator, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.hidden = true;
      this.style.display = 'none';

      if (!this.parentElement || this.parentElement.tagName.toLowerCase() !== 'data-table') {
        console.error('DataTablePaginator musi być umieszczony wewnątrz elementu <data-table>.');
        this.parentElement.removeChild(this);
      }
    }
  }, {
    key: "update",
    value: function update(total, reset) {
      this._totalRecords = total || 0;

      if (reset) {
        this._page = 1;
      }

      this.render();
    }
  }, {
    key: "render",
    value: function render() {
      this._first.classList.remove('disabled');

      this._prev.classList.remove('disabled');

      this._next.classList.remove('disabled');

      this._last.classList.remove('disabled');

      if (!this.hasPrev || this.disabled) {
        this._first.classList.add('disabled');

        this._prev.classList.add('disabled');
      }

      if (!this.hasNext || this.disabled) {
        this._next.classList.add('disabled');

        this._last.classList.add('disabled');
      }

      if (this._totalRecords < 1) {
        this._stats.textContent = '0 / 0';
      } else {
        var length = Math.max(this._totalRecords, 0);
        var startIndex = (this._page - 1) * this._size; // If the start index exceeds the list length, do not try and fix the end index to the end.

        var endIndex = startIndex < length ? Math.min(startIndex + this._size, length) : startIndex + this._size;
        this._stats.textContent = "".concat(startIndex + 1, " - ").concat(endIndex, " / ").concat(length);
      }

      while (this._sizesSelect.firstChild) {
        this._sizesSelect.removeChild(this._sizesSelect.firstChild);
      }

      var _iterator9 = _createForOfIteratorHelper(this.sizeOptions),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var size = _step9.value;

          var option = this._sizesSelect.appendChild(document.createElement('option'));

          option.value = option.textContent = size;

          if (parseInt(size) === this.size) {
            option.selected = true;
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
  }, {
    key: "first",
    value: function first() {
      if (!this.hasPrev || this.disabled) {
        return;
      }

      this._page = 1;
      this.dispatchEvent(new CustomEvent('page', {
        detail: this._page
      }));
    }
  }, {
    key: "prev",
    value: function prev() {
      if (!this.hasPrev || this.disabled) {
        return;
      }

      this._page = this._page - 1;
      this.dispatchEvent(new CustomEvent('page', {
        detail: this._page
      }));
    }
  }, {
    key: "next",
    value: function next() {
      if (!this.hasNext || this.disabled) {
        return;
      }

      this._page = this._page + 1;
      this.dispatchEvent(new CustomEvent('page', {
        detail: this._page
      }));
    }
  }, {
    key: "last",
    value: function last() {
      if (!this.hasNext || this.disabled) {
        return;
      }

      this._page = this.lastPage;
      this.dispatchEvent(new CustomEvent('page', {
        detail: this._page
      }));
    }
  }, {
    key: "lastPage",
    get: function get() {
      return this._size > 0 ? Math.ceil(this._totalRecords / this._size) : 0;
    }
  }, {
    key: "page",
    get: function get() {
      return this._page;
    }
  }, {
    key: "size",
    get: function get() {
      return this._size;
    }
  }, {
    key: "_element",
    get: function get() {
      return this._container;
    }
  }, {
    key: "hasNext",
    get: function get() {
      return this._page < this.lastPage;
    }
  }, {
    key: "hasPrev",
    get: function get() {
      return this._page > 1;
    }
  }]);

  return DataTablePaginator;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var DataTableCustomFilter = /*#__PURE__*/function (_HTMLElement5) {
  _inherits(DataTableCustomFilter, _HTMLElement5);

  var _super5 = _createSuper(DataTableCustomFilter);

  function DataTableCustomFilter() {
    _classCallCheck(this, DataTableCustomFilter);

    return _super5.apply(this, arguments);
  }

  _createClass(DataTableCustomFilter, [{
    key: "value",
    get: function get() {
      return void 0;
    }
  }, {
    key: "element",
    get: function get() {
      return void 0;
    }
  }]);

  return DataTableCustomFilter;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var DataTableCustomRenderer = /*#__PURE__*/function (_HTMLElement6) {
  _inherits(DataTableCustomRenderer, _HTMLElement6);

  var _super6 = _createSuper(DataTableCustomRenderer);

  function DataTableCustomRenderer() {
    _classCallCheck(this, DataTableCustomRenderer);

    return _super6.apply(this, arguments);
  }

  _createClass(DataTableCustomRenderer, [{
    key: "render",
    value: function render(value, row) {
      return '-';
    }
  }]);

  return DataTableCustomRenderer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

var DataTableDefaultFilter = /*#__PURE__*/function (_DataTableCustomFilte) {
  _inherits(DataTableDefaultFilter, _DataTableCustomFilte);

  var _super7 = _createSuper(DataTableDefaultFilter);

  function DataTableDefaultFilter() {
    var _this9;

    _classCallCheck(this, DataTableDefaultFilter);

    _this9 = _super7.call(this);
    _this9._div = document.createElement('div');
    _this9._input = _this9._div.appendChild(document.createElement('input'));
    _this9._input.style.boxSizing = 'border-box';
    _this9._input.style.width = '100%';
    _this9._input.style.border = 'none';
    _this9._input.style.borderBottom = '1px solid lightgrey';
    _this9._input.type = 'text';

    _this9._input.setAttribute('placeholder', 'Szukaj');

    _this9._input.addEventListener('input', function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this9.dispatchEvent(new CustomEvent('filter', {
        detail: _this9.value
      }));
    });

    return _this9;
  }

  _createClass(DataTableDefaultFilter, [{
    key: "element",
    get: function get() {
      return this._div;
    }
  }, {
    key: "value",
    get: function get() {
      var value = this._input.value.trim();

      return value.length > 0 ? value : void 0;
    }
  }]);

  return DataTableDefaultFilter;
}(DataTableCustomFilter);

var DataTableSelectFilter = /*#__PURE__*/function (_DataTableCustomFilte2) {
  _inherits(DataTableSelectFilter, _DataTableCustomFilte2);

  var _super8 = _createSuper(DataTableSelectFilter);

  _createClass(DataTableSelectFilter, [{
    key: "element",
    get: function get() {
      return this._div;
    }
  }, {
    key: "value",
    get: function get() {
      if (this._multiple) {
        var result = [];
        var options = select && select.options;
        var opt;

        for (var i = 0, iLen = options.length; i < iLen; i++) {
          opt = options[i];

          if (opt.selected) {
            result.push(opt.value || opt.text);
          }
        }

        return result ? result : void 0;
      }

      return this._select.value && this._select.value.length ? this._select.value.trim() : void 0;
    }
  }]);

  function DataTableSelectFilter() {
    var _this10;

    _classCallCheck(this, DataTableSelectFilter);

    _this10 = _super8.call(this);
    _this10._multiple = _this10.hasAttribute('multiple');
    _this10._div = document.createElement('div');
    _this10._select = _this10._div.appendChild(document.createElement('select'));
    _this10._select.style.boxSizing = 'border-box';
    _this10._select.style.width = '100%';

    if (_this10._multiple) {
      _this10._select.setAttribute('multiple', true);
    }

    _this10._observer = new MutationObserver(function () {
      _this10._updateOptions();
    });

    _this10._select.addEventListener('change', function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this10.dispatchEvent(new CustomEvent('filter', {
        detail: _this10.value
      }));
    });

    return _this10;
  }

  _createClass(DataTableSelectFilter, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this11 = this;

      setTimeout(function () {
        _this11._updateOptions();

        _this11._observer.observe(_this11, {
          childList: true
        });
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this._observer.disconnect();
    }
  }, {
    key: "_updateOptions",
    value: function _updateOptions() {
      while (this._select.firstChild) {
        this._select.removeChild(this._select.firstChild);
      }

      var options = this.querySelectorAll('data-table-select-filter-option');

      this._select.appendChild(document.createElement('option'));

      for (var _i4 = 0, _Array$from3 = Array.from(options); _i4 < _Array$from3.length; _i4++) {
        var option = _Array$from3[_i4];

        var el = this._select.appendChild(document.createElement('option'));

        el.setAttribute('value', option.value);
        el.textContent = option.text;
      }
    }
  }]);

  return DataTableSelectFilter;
}(DataTableCustomFilter);

var DataTableCheckboxFilter = /*#__PURE__*/function (_DataTableCustomFilte3) {
  _inherits(DataTableCheckboxFilter, _DataTableCustomFilte3);

  var _super9 = _createSuper(DataTableCheckboxFilter);

  _createClass(DataTableCheckboxFilter, [{
    key: "element",
    get: function get() {
      return this._div;
    }
  }, {
    key: "value",
    get: function get() {
      var values = [];

      var _iterator10 = _createForOfIteratorHelper(this._fieldset.childNodes),
          _step10;

      try {
        for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
          var span = _step10.value;

          var _iterator11 = _createForOfIteratorHelper(span.childNodes),
              _step11;

          try {
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              var checkbox = _step11.value;

              if (checkbox instanceof HTMLInputElement && checkbox.checked) {
                values.push(checkbox.value);
              }
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }
        }
      } catch (err) {
        _iterator10.e(err);
      } finally {
        _iterator10.f();
      }

      return values.length ? values : void 0;
    }
  }]);

  function DataTableCheckboxFilter() {
    var _this12;

    _classCallCheck(this, DataTableCheckboxFilter);

    _this12 = _super9.call(this);
    _this12._multiple = _this12.hasAttribute('multiple');
    _this12._div = document.createElement('div');
    _this12._fieldset = _this12._div.appendChild(document.createElement('fieldset'));
    _this12._checkboxes = [];
    _this12._observer = new MutationObserver(function () {
      _this12._updateOptions();
    });

    _this12._fieldset.addEventListener('change', function (e) {
      if (e.target instanceof HTMLInputElement || e.target instanceof HTMLLabelElement) {
        e.preventDefault();
        e.stopPropagation();

        _this12.dispatchEvent(new CustomEvent('filter', {
          detail: _this12.value
        }));
      }
    });

    return _this12;
  }

  _createClass(DataTableCheckboxFilter, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this13 = this;

      setTimeout(function () {
        _this13._updateOptions();

        _this13._observer.observe(_this13, {
          childList: true
        });
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this._observer.disconnect();
    }
  }, {
    key: "_updateOptions",
    value: function _updateOptions() {
      while (this._fieldset.firstChild) {
        this._fieldset.removeChild(this._fieldset.firstChild);
      }

      var options = this.querySelectorAll('data-table-select-filter-option');

      for (var _i5 = 0, _Array$from4 = Array.from(options); _i5 < _Array$from4.length; _i5++) {
        var option = _Array$from4[_i5];

        var spanEl = this._fieldset.appendChild(document.createElement('span'));

        spanEl.style.whiteSpace = 'nowrap';
        var inputEl = spanEl.appendChild(document.createElement('input'));
        inputEl.setAttribute('value', option.value);
        inputEl.setAttribute('id', 'option' + option.value);

        if (option.hasAttribute('title')) {
          spanEl.setAttribute('title', option.title);
        }

        if (option.hasAttribute('selected')) {
          inputEl.checked = true;
        }

        inputEl.setAttribute('type', 'checkbox');
        var labelEl = spanEl.appendChild(document.createElement('label'));
        labelEl.setAttribute('for', 'option' + option.value);
        labelEl.textContent = option.text;
      }
    }
  }]);

  return DataTableCheckboxFilter;
}(DataTableCustomFilter);

var DataTableComboBoxMultipleFilter = /*#__PURE__*/function (_DataTableCustomFilte4) {
  _inherits(DataTableComboBoxMultipleFilter, _DataTableCustomFilte4);

  var _super10 = _createSuper(DataTableComboBoxMultipleFilter);

  _createClass(DataTableComboBoxMultipleFilter, [{
    key: "element",
    get: function get() {
      return this._div;
    }
  }, {
    key: "value",
    get: function get() {
      var values = [];

      var _iterator12 = _createForOfIteratorHelper(this._fieldList.querySelectorAll('input[type="checkbox"]')),
          _step12;

      try {
        for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
          var checkbox = _step12.value;

          if (checkbox.checked) {
            if (this._type === 'integer') {
              var intValue = parseInt(checkbox.value);

              if (!isNaN(intValue)) {
                values.push(intValue);
              }
            } else {
              values.push(checkbox.value);
            }
          }
        }
      } catch (err) {
        _iterator12.e(err);
      } finally {
        _iterator12.f();
      }

      return values.length ? values : void 0;
    }
  }]);

  function DataTableComboBoxMultipleFilter() {
    var _this14;

    _classCallCheck(this, DataTableComboBoxMultipleFilter);

    _this14 = _super10.call(this);
    _this14._type = _this14.hasAttribute('type') ? _this14.getAttribute('type') : null;
    _this14._div = document.createElement('div');
    _this14._decorationDiv = _this14._div.appendChild(document.createElement('div'));
    _this14._decorationTextDiv = _this14._decorationDiv.appendChild(document.createElement('div'));
    _this14._decorationArrowDiv = _this14._decorationDiv.appendChild(document.createElement('div'));
    _this14._fieldsDiv = _this14._div.appendChild(document.createElement('div'));
    _this14._fieldList = _this14._fieldsDiv.appendChild(document.createElement('ul'));
    var selectWidth = '150px';
    _this14._div.style.width = selectWidth;
    _this14._decorationDiv.style.border = '1px solid darkgray';
    _this14._decorationDiv.style.backgroundColor = '#f7f3f3';
    _this14._decorationDiv.style.display = 'flex';
    _this14._decorationDiv.style.width = selectWidth;
    _this14._decorationDiv.style.height = '24px';
    _this14._decorationDiv.style.borderRadius = '3px';
    _this14._decorationDiv.style.paddingLeft = '3px';
    _this14._decorationDiv.style.paddingRight = '3px';
    _this14._decorationTextDiv.style.overflow = 'hidden';
    _this14._decorationTextDiv.style.wordBreak = 'keep-all';
    _this14._decorationTextDiv.style.whiteSpace = 'nowrap';
    _this14._decorationTextDiv.style.textOverflow = 'ellipsis';
    _this14._decorationTextDiv.textContent = 'Nic nie wybrano';
    _this14._decorationTextDiv.style.cursor = 'default';
    _this14._decorationArrowDiv.style.width = '24px';

    var svg = _this14._decorationArrowDiv.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'svg'));

    svg.setAttribute('viewBox', '0 0 24 24');
    svg.style.height = '24px';
    svg.style.width = '24px';
    svg.style.transform = 'rotate(-90deg)';
    var svgPath = svg.appendChild(document.createElementNS('http://www.w3.org/2000/svg', 'path'));
    svgPath.setAttribute('d', 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z');
    _this14._decorationArrowDiv.style.marginLeft = 'auto';
    _this14._fieldsDiv.hidden = true;
    _this14._fieldsDiv.style.border = '1px solid black';
    _this14._fieldsDiv.style.minWidth = selectWidth;
    _this14._fieldsDiv.style.maxWidth = '200px';
    _this14._fieldsDiv.style.backgroundColor = 'white';
    _this14._fieldsDiv.style.position = 'absolute';
    _this14._fieldsDiv.style.paddingRight = '10px';
    _this14._fieldsDiv.style.textAlign = 'left';
    _this14._fieldsDiv.style.zIndex = 10;
    _this14._fieldList.style.listStyle = 'none';
    _this14._fieldList.style.paddingLeft = 0;

    _this14._windowClickCallback = function (e) {
      if (_this14._fieldsDiv.hidden) {
        return;
      }

      var decorationRect = _this14._decorationDiv.getBoundingClientRect();

      var fieldsRect = _this14._fieldsDiv.getBoundingClientRect();

      if (decorationRect.left <= e.clientX && decorationRect.top <= e.clientY && decorationRect.right >= e.clientX && decorationRect.bottom >= e.clientY) {
        return;
      }

      if (fieldsRect.left <= e.clientX && fieldsRect.top <= e.clientY && fieldsRect.right >= e.clientX && fieldsRect.bottom >= e.clientY) {
        return;
      }

      _this14._fieldsDiv.hidden = true;

      _this14.updateSelectedLabels();
    };

    _this14._decorationDiv.addEventListener('click', function () {
      _this14._fieldsDiv.hidden = !_this14._fieldsDiv.hidden;
    });

    window.addEventListener('click', _this14._windowClickCallback);
    _this14._observer = new MutationObserver(function () {
      _this14._updateOptions();

      _this14.updateSelectedLabels();
    });

    _this14._fieldList.addEventListener('change', function (e) {
      e.preventDefault();
      e.stopPropagation();

      _this14.dispatchEvent(new CustomEvent('filter', {
        detail: _this14.value
      }));

      _this14.updateSelectedLabels();
    });

    return _this14;
  }

  _createClass(DataTableComboBoxMultipleFilter, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this15 = this;

      setTimeout(function () {
        _this15._updateOptions();

        _this15.updateSelectedLabels();

        _this15._observer.observe(_this15, {
          childList: true
        });
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this._observer.disconnect();
    }
  }, {
    key: "_updateOptions",
    value: function _updateOptions() {
      while (this._fieldList.firstChild) {
        this._fieldList.removeChild(this._fieldList.firstChild);
      }

      var options = this.querySelectorAll('data-table-select-filter-option');

      for (var _i6 = 0, _Array$from5 = Array.from(options); _i6 < _Array$from5.length; _i6++) {
        var option = _Array$from5[_i6];

        var li = this._fieldList.appendChild(document.createElement('li'));

        li.style.whiteSpace = 'nowrap';
        li.style.overflow = 'hidden';
        li.style.textOverflow = 'ellipsis';
        var checkbox = li.appendChild(document.createElement('input'));
        checkbox.setAttribute('type', 'checkbox');
        checkbox.setAttribute('value', option.value);
        var randomId = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5);
        checkbox.setAttribute('id', randomId);
        checkbox.style.marginLeft = '10px';

        if (option.hasAttribute('selected')) {
          checkbox.checked = true;
        }

        var label = li.appendChild(document.createElement('label'));
        label.setAttribute('for', randomId);
        label.setAttribute('title', option.hasAttribute('title') ? option.getAttribute('title') : option.text);
        label.style.wordBreak = 'keep-all';
        label.textContent = option.text;
      }
    }
  }, {
    key: "_getSelectedLabels",
    value: function _getSelectedLabels() {
      var result = [];

      var _iterator13 = _createForOfIteratorHelper(this._fieldList.querySelectorAll('li')),
          _step13;

      try {
        for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
          var li = _step13.value;
          var checkbox = li.querySelector('input[type="checkbox"]');
          var label = li.querySelector('label');

          if (checkbox instanceof HTMLInputElement && checkbox.checked) {
            result.push(label.textContent);
          }
        }
      } catch (err) {
        _iterator13.e(err);
      } finally {
        _iterator13.f();
      }

      return result;
    }
  }, {
    key: "updateSelectedLabels",
    value: function updateSelectedLabels() {
      this._decorationTextDiv.title = this._decorationTextDiv.textContent = this._getSelectedLabels().length > 0 ? this._getSelectedLabels().join(', ') : 'Nic nie wybrano';
    }
  }]);

  return DataTableComboBoxMultipleFilter;
}(DataTableCustomFilter);

customElements.define('data-table', DataTable);
customElements.define('data-table-header', DataTableHeader);
customElements.define('data-table-internal-sorter', DataTableSorter);
customElements.define('data-table-paginator', DataTablePaginator);
customElements.define('data-table-filter-default', DataTableDefaultFilter);
customElements.define('data-table-renderer-default', /*#__PURE__*/function (_DataTableCustomRende) {
  _inherits(_class, _DataTableCustomRende);

  var _super11 = _createSuper(_class);

  function _class() {
    _classCallCheck(this, _class);

    return _super11.apply(this, arguments);
  }

  _createClass(_class, [{
    key: "render",
    value: function render(value, row) {
      return value !== undefined && value !== null && value !== '' ? value : _get(_getPrototypeOf(_class.prototype), "render", this).call(this, value, row);
    }
  }]);

  return _class;
}(DataTableCustomRenderer));
customElements.define('data-table-select-filter', DataTableSelectFilter);
customElements.define('data-table-checkbox-filter', DataTableCheckboxFilter);
customElements.define('data-table-combobox-multiple-filter', DataTableComboBoxMultipleFilter);
customElements.define('data-table-select-filter-option', /*#__PURE__*/function (_HTMLElement7) {
  _inherits(_class2, _HTMLElement7);

  var _super12 = _createSuper(_class2);

  function _class2() {
    _classCallCheck(this, _class2);

    return _super12.apply(this, arguments);
  }

  _createClass(_class2, [{
    key: "value",
    get: function get() {
      return this.getAttribute('value');
    }
  }, {
    key: "text",
    get: function get() {
      return "".concat(this.textContent).trim();
    }
  }]);

  return _class2;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement)));
customElements.define('data-table-select-integer-filter', /*#__PURE__*/function (_DataTableSelectFilte) {
  _inherits(_class3, _DataTableSelectFilte);

  var _super13 = _createSuper(_class3);

  function _class3() {
    _classCallCheck(this, _class3);

    return _super13.apply(this, arguments);
  }

  _createClass(_class3, [{
    key: "value",
    get: function get() {
      if (this._multiple) {
        var result = [];
        var options = this._select && this._select.options;
        var opt;

        for (var i = 0, iLen = options.length; i < iLen; i++) {
          opt = options[i];

          if (opt.selected) {
            var value = opt.value || opt.text;
            var intValue = parseInt(value);

            if (!isNaN(intValue)) {
              result.push(intValue);
            }
          }
        }

        return result.length ? result : void 0;
      }

      if (this._select.value && this._select.value.length) {
        var _intValue = parseInt(this._select.value.trim());

        if (!isNaN(_intValue)) {
          return _intValue;
        }
      }

      return void 0;
    }
  }]);

  return _class3;
}(DataTableSelectFilter));
customElements.define('data-table-checkbox-integer-filter', /*#__PURE__*/function (_DataTableCheckboxFil) {
  _inherits(_class4, _DataTableCheckboxFil);

  var _super14 = _createSuper(_class4);

  function _class4() {
    _classCallCheck(this, _class4);

    return _super14.apply(this, arguments);
  }

  _createClass(_class4, [{
    key: "value",
    get: function get() {
      var values = [];

      var _iterator14 = _createForOfIteratorHelper(this._fieldset.childNodes),
          _step14;

      try {
        for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
          var span = _step14.value;

          var _iterator15 = _createForOfIteratorHelper(span.childNodes),
              _step15;

          try {
            for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
              var checkbox = _step15.value;

              if (checkbox instanceof HTMLInputElement && checkbox.checked) {
                var intValue = parseInt(checkbox.value);

                if (!isNaN(intValue)) {
                  values.push(intValue);
                }
              }
            }
          } catch (err) {
            _iterator15.e(err);
          } finally {
            _iterator15.f();
          }
        }
      } catch (err) {
        _iterator14.e(err);
      } finally {
        _iterator14.f();
      }

      return values.length ? values : void 0;
    }
  }]);

  return _class4;
}(DataTableCheckboxFilter));
customElements.define('data-table-severity-renderer', /*#__PURE__*/function (_DataTableCustomRende2) {
  _inherits(_class5, _DataTableCustomRende2);

  var _super15 = _createSuper(_class5);

  function _class5() {
    _classCallCheck(this, _class5);

    return _super15.apply(this, arguments);
  }

  _createClass(_class5, [{
    key: "render",
    value: function render(value, row) {
      var span = document.createElement('span');
      span.textContent = value;
      span.style.border = '1px solid black';
      span.style.borderRadius = '5px';
      span.style.padding = '5px 10px';
      span.style.fontWeight = 'bold';

      switch ((value || '').toLowerCase()) {
        case 'krytyczna':
          span.style.backgroundColor = 'red';
          span.style.color = 'white';
          break;

        case 'wysoka':
          span.style.backgroundColor = 'orange';
          span.style.color = 'white';
          break;

        case 'średnia':
          span.style.backgroundColor = 'yellow';
          break;

        case 'niska':
          break;

        case 'log':
          break;

        case 'info':
          break;
      }

      return span;
    }
  }]);

  return _class5;
}(DataTableCustomRenderer));
customElements.define('data-table-string-list-renderer', /*#__PURE__*/function (_DataTableCustomRende3) {
  _inherits(_class6, _DataTableCustomRende3);

  var _super16 = _createSuper(_class6);

  function _class6() {
    var _this16;

    _classCallCheck(this, _class6);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this16 = _super16.call.apply(_super16, [this].concat(args));

    if (_this16.hasAttribute('char-limit')) {
      _this16.charLimit = parseInt(_this16.getAttribute('char-limit'));
    } else {
      _this16.charLimit = null;
    }

    return _this16;
  }

  _createClass(_class6, [{
    key: "render",
    value: function render(value, row) {
      if (!value) {
        return '-';
      }

      var ul = document.createElement('ul');

      var _iterator16 = _createForOfIteratorHelper(value),
          _step16;

      try {
        for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
          var valueElement = _step16.value;
          var li = document.createElement('li');
          var ellipsisSuffix = '...';

          if (this.charLimit !== null && valueElement.length > this.charLimit) {
            li.textContent = valueElement.substr(0, this.charLimit - ellipsisSuffix.length) + ellipsisSuffix;
          } else {
            li.textContent = valueElement;
          }

          ul.appendChild(li);
        }
      } catch (err) {
        _iterator16.e(err);
      } finally {
        _iterator16.f();
      }

      return ul;
    }
  }]);

  return _class6;
}(DataTableCustomRenderer));
customElements.define('data-table-url-renderer', /*#__PURE__*/function (_DataTableCustomRende4) {
  _inherits(_class7, _DataTableCustomRende4);

  var _super17 = _createSuper(_class7);

  function _class7() {
    _classCallCheck(this, _class7);

    return _super17.apply(this, arguments);
  }

  _createClass(_class7, [{
    key: "render",
    value: function render(value, row) {
      if (!value) {
        return '-';
      }

      var link = document.createElement('a');
      link.href = value;
      link.textContent = value;
      return link;
    }
  }]);

  return _class7;
}(DataTableCustomRenderer)); // For FUN

customElements.define('data-table-italic-bold-renderer', /*#__PURE__*/function (_DataTableCustomRende5) {
  _inherits(_class8, _DataTableCustomRende5);

  var _super18 = _createSuper(_class8);

  function _class8() {
    _classCallCheck(this, _class8);

    return _super18.apply(this, arguments);
  }

  _createClass(_class8, [{
    key: "render",
    value: function render(value, row) {
      var el = document.createElement('i');
      el.appendChild(document.createElement('b')).textContent = value;
      return el;
    }
  }]);

  return _class8;
}(DataTableCustomRenderer));
customElements.define('data-table-actions-renderer', /*#__PURE__*/function (_DataTableCustomRende6) {
  _inherits(_class9, _DataTableCustomRende6);

  var _super19 = _createSuper(_class9);

  function _class9() {
    _classCallCheck(this, _class9);

    return _super19.apply(this, arguments);
  }

  _createClass(_class9, [{
    key: "render",
    value: function render(value, row) {
      var el = document.createElement('span');

      var _iterator17 = _createForOfIteratorHelper(value.split(';')),
          _step17;

      try {
        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
          var action = _step17.value;
          var actionParts = action.split('^');
          var label = actionParts[0];
          var url = actionParts[1];
          var tooltip = actionParts[2];
          var a = document.createElement('a');
          a.href = url;
          a.textContent = label;

          if (typeof tooltip !== 'undefined') {
            a.title = tooltip;
          }

          el.appendChild(a);
          el.appendChild(document.createTextNode(' '));
        }
      } catch (err) {
        _iterator17.e(err);
      } finally {
        _iterator17.f();
      }

      return el;
    }
  }]);

  return _class9;
}(DataTableCustomRenderer));
"use strict";

function createEvent(eventName, details) {
  if (typeof CustomEvent === 'function') {
    return new CustomEvent(eventName, {
      detail: details
    });
  }

  var event = document.createEvent('CustomEvent');
  event.initCustomEvent(eventName, true, true, details);
  return event;
}

String.prototype.toSnake = function () {
  return this.replace(/[\w]([A-Z])/g, function (m) {
    return m[0] + "_" + m[1];
  }).toLowerCase();
};

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (search, this_len) {
    if (this_len === undefined || this_len > this.length) {
      this_len = this.length;
    }

    return this.substring(this_len - search.length, this_len) === search;
  };
}

if (typeof IE === 'undefined' || IE) {
  var old = DOMTokenList.prototype.add;

  DOMTokenList.prototype.add = function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    for (var _i = 0, _args = args; _i < _args.length; _i++) {
      var arg = _args[_i];
      old.call(this, arg);
    }
  };
}

Number.isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};

Number.isNaN = Number.isNaN || function (value) {
  return value !== value;
};

Number.prototype.toTime = function () {
  return Math.floor(this / 60) + ':' + ('0' + this % 60).slice(-2);
};

if (!Array.prototype.forEach) {
  Array.prototype.forEach = function (fun
  /*, thisP*/
  ) {
    var len = this.length;

    if (typeof fun !== "function") {
      throw new TypeError();
    }

    var thisP = arguments[1];

    for (var i = 0; i < len; i++) {
      if (i in this) {
        fun.call(thisP, this[i], i, this);
      }
    }
  };
}

NodeList.prototype.forEach = NodeList.prototype.forEach || Array.prototype.forEach;

HTMLElement.prototype.remove = HTMLElement.prototype.remove || function () {
  if (this.parentElement) this.parentElement.removeChild(this);
};

if (!Element.prototype.matches) {
  // noinspection JSUnresolvedVariable
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (selector) {
    var el = this;

    do {
      if (el.matches(selector)) {
        return el;
      }

      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);

    return null;
  };
}

if (!Date.prototype.format) {
  Date.prototype.format = function (time, seconds) {
    var result = this.getFullYear() + '-' + ('0' + (this.getMonth() + 1)).slice(-2) + '-' + ('0' + this.getDate()).slice(-2);

    if (time || time === void 0) {
      result += ' ' + ('0' + this.getHours()).slice(-2);
      result += ':' + ('0' + this.getMinutes()).slice(-2);

      if (seconds) {
        result += ':' + ('0' + this.getSeconds()).slice(-2);
      }
    }

    return result;
  };
}

if (!HTMLElement.prototype.clear) {
  HTMLElement.prototype.clear = function () {
    while (this.lastChild) {
      this.removeChild(this.lastChild);
    }

    return this;
  };
}

function sleep(ms) {
  return new Promise(function (resolve) {
    return setTimeout(resolve, ms);
  });
}
"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _classStaticPrivateMethodGet(receiver, classConstructor, method) { if (receiver !== classConstructor) { throw new TypeError("Private static access of wrong provenance"); } return method; }

var Api = /*#__PURE__*/function () {
  function Api() {
    _classCallCheck(this, Api);
  }

  _createClass(Api, null, [{
    key: "init",
    value: function init() {
      _classStaticPrivateMethodGet(Api, Api, _realTableRWD).call(Api);

      _classStaticPrivateMethodGet(Api, Api, _chartFilters).call(Api);

      _classStaticPrivateMethodGet(Api, Api, _tableFilters).call(Api);

      _classStaticPrivateMethodGet(Api, Api, _simpleTabs).call(Api);

      _classStaticPrivateMethodGet(Api, Api, _radioTab).call(Api);

      _classStaticPrivateMethodGet(Api, Api, _infoAuthorizationPopup).call(Api);

      _classStaticPrivateMethodGet(Api, Api, _afterLoginModal).call(Api);

      ApiServicesAccordion.init(); //zarządzanie usługami w edycji firmy - accordion

      ApiCheckboxTree.init(); //zarządzanie drzewem checkboxów w edycji DDoS firmy

      ApiUserAuthenticateConfig.init(); //dodaje obsługę wyboru typu autentykacji w ustawieniach użytkownika

      ApiForms.init(); //elementy związane z formularzami

      ApiCmsFixLayout.init(); //elementy związane z funkcjonalnością ogólnego layoutu

      ApiLogin.init(); //strona logowania

      ApiNotification.init(); //notyfikacje

      var $authorizationInfoModal = $('#authorizationInfoModal');
      var $afterLoginModal = $('#afterLoginModal');

      if ($authorizationInfoModal.length) {
        $authorizationInfoModal.modal('show'); //odpalenie modalu
      }

      if ($afterLoginModal.length) {
        $afterLoginModal.modal('show'); //odpalenie modalu
      }
    }
  }]);

  return Api;
}();

var _afterLoginModal = function _afterLoginModal() {
  $('#afterLoginModal .btn').on('click', function () {
    var date = new Date();
    date.setDate(date.getDate() + 1);
    Cookies.set('popup_after_login_showed', '1', {
      expires: date
    });
  });
};

var _infoAuthorizationPopup = function _infoAuthorizationPopup() {
  $('#authorizationInfoModal .btn').on('click', function () {
    Cookies.set('howAuthorizationInfoModalShowed', '1');
  });
};

var _tableFilters = function _tableFilters() {
  if (!$('.filterData').is(':checked')) {
    $('.table-filters').hide();
  }

  $('#datePeriod_tablePeriodType input[type=radio]').on('click', function () {
    if ($(this).val() === 'period') {
      $('.table-filters').show('fast');
    } else {
      $('.table-filters').hide('fast');
    }
  });

  if ($('#datePeriod_tablePeriodType input[type=radio][value=period]').is(':checked')) {
    $('.table-filters').show();
  } else {
    $('.table-filters').hide();
  }
};

var _chartFilters = function _chartFilters() {
  if (!$('.filterData').is(':checked')) {
    $('.filters').hide();
  }

  $('#datePeriod_periodType input[type=radio]').on('click', function () {
    if ($(this).val() === 'period') {
      $('.filters').show('fast');
    } else {
      $('.filters').hide('fast');
    }
  });

  if ($('#datePeriod_periodType input[type=radio][value=period]').is(':checked')) {
    $('.filters').show();
  } else {
    $('.filters').hide();
  }
};

var _simpleTabs = function _simpleTabs() {
  $('.char-tab-toggle').on('click', function (e) {
    e.preventDefault();
    var $target = $($(this).attr('href'));

    if ($target.length) {
      $target.siblings().removeClass('active');
      $target.addClass('active');
    }

    $(this).closest('.card-header').find('h2').text($(this).text());
  });
};

var _radioTab = function _radioTab() {
  // noinspection JSUnusedLocalSymbols
  $('.tabs-radio input:radio').on('click', function (e) {
    var $target = $($(this).attr('data-target'));
    $target.siblings().hide();
    $target.fadeIn();
  });
};

var _realTableRWD = function _realTableRWD() {
  $('.table').each(function () {
    var $tr = $(this).find('tbody tr');
    $(this).find('thead th').each(function (i) {
      var text = $(this).text();
      var reg = new RegExp('[a-z]', 'i');

      if (reg.test(text)) {
        $tr.each(function () {
          $(this).find('td:eq(' + i + ')').attr('data-td-title', text).addClass('rwd');
        });
      }
    });
  });
};

$(function () {
  Api.init();
});